(() => {
  const formatMoney = (amountInCents, locale, currency) => {
    try {
      return new Intl.NumberFormat(locale || 'pt-BR', {
        style: 'currency',
        currency: currency || 'BRL'
      }).format((Number(amountInCents) || 0) / 100);
    } catch (error) {
      return `R$ ${((Number(amountInCents) || 0) / 100).toFixed(2).replace('.', ',')}`;
    }
  };

  const initProduct = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const variantsNode = root.querySelector('[data-variant-json]');
    let variants = [];

    try {
      variants = JSON.parse(variantsNode?.textContent || '[]');
    } catch (error) {
      console.error('Soleah: não foi possível ler as variantes.', error);
    }

    const locale = root.dataset.locale || 'pt-BR';
    const currency = root.dataset.currency || 'BRL';
    const installments = Math.max(1, Number(root.dataset.installments) || 1);
    const productUrl = root.dataset.productUrl || window.location.pathname;

    const variantInput = root.querySelector('[data-variant-id]');
    const optionInputs = [...root.querySelectorAll('[data-option-input]')];
    const priceNode = root.querySelector('[data-price]');
    const comparePriceNode = root.querySelector('[data-compare-price]');
    const installmentsNode = root.querySelector('[data-installments-text]');
    const addButton = root.querySelector('[data-add-button]');
    const addButtonText = root.querySelector('[data-add-button-text]');
    const stockStatus = root.querySelector('[data-stock-status]');

    const showMedia = (mediaId) => {
      if (!mediaId) return;

      root.querySelectorAll('[data-media-slide]').forEach((slide) => {
        const isActive = String(slide.dataset.mediaSlide) === String(mediaId);
        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;

        if (!isActive) {
          slide.querySelectorAll('video').forEach((video) => video.pause());
        }
      });

      root.querySelectorAll('[data-media-target]').forEach((button) => {
        const isActive = String(button.dataset.mediaTarget) === String(mediaId);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    root.querySelectorAll('[data-media-target]').forEach((button) => {
      button.addEventListener('click', () => showMedia(button.dataset.mediaTarget));
    });

    const selectedOptions = () => {
      const positions = [...new Set(optionInputs.map((input) => Number(input.closest('[data-option-position]')?.dataset.optionPosition || 0)))].sort((a, b) => a - b);

      return positions.map((position) => {
        const selected = root.querySelector(`[data-option-position="${position}"] [data-option-input]:checked`);
        return selected?.value || '';
      });
    };

    const updateOptionLabels = () => {
      root.querySelectorAll('[data-option-position]').forEach((group) => {
        const position = group.dataset.optionPosition;
        const selected = group.querySelector('[data-option-input]:checked');
        const label = root.querySelector(`[data-selected-option="${position}"]`);
        if (label && selected) label.textContent = selected.value;
      });
    };

    const updateVariant = () => {
      const options = selectedOptions();
      const variant = variants.find((item) => item.options.every((option, index) => option === options[index]));

      updateOptionLabels();

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addButtonText) addButtonText.textContent = 'Combinação indisponível';
        if (stockStatus) {
          stockStatus.classList.add('is-unavailable');
          stockStatus.lastElementChild.textContent = 'Combinação indisponível';
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (priceNode) priceNode.textContent = formatMoney(variant.price, locale, currency);

      if (comparePriceNode) {
        const showCompare = Number(variant.compareAtPrice) > Number(variant.price);
        comparePriceNode.classList.toggle('is-hidden', !showCompare);
        comparePriceNode.textContent = showCompare ? formatMoney(variant.compareAtPrice, locale, currency) : '';
      }

      if (installmentsNode) {
        installmentsNode.textContent = `ou ${installments}x de ${formatMoney(variant.price / installments, locale, currency)} sem juros`;
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addButtonText) addButtonText.textContent = variant.available ? 'Adicionar à sacola' : 'Produto indisponível';

      if (stockStatus) {
        stockStatus.classList.toggle('is-unavailable', !variant.available);
        stockStatus.lastElementChild.textContent = variant.available ? 'Em estoque' : 'Indisponível';
      }

      if (variant.featuredMediaId) showMedia(variant.featuredMediaId);

      const nextUrl = new URL(productUrl, window.location.origin);
      nextUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', `${nextUrl.pathname}${nextUrl.search}`);
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

    const quantityInput = root.querySelector('[data-quantity-input]');
    const sanitizeQuantity = () => {
      if (!quantityInput) return;
      const value = Math.max(1, parseInt(quantityInput.value, 10) || 1);
      quantityInput.value = value;
    };

    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) - 1);
    });

    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) + 1);
    });

    quantityInput?.addEventListener('change', sanitizeQuantity);

    const lightbox = root.querySelector('[data-lightbox]');
    const lightboxImage = root.querySelector('[data-lightbox-image]');
    const lightboxCounter = root.querySelector('[data-lightbox-counter]');
    const lightboxPrevious = root.querySelector('[data-lightbox-previous]');
    const lightboxNext = root.querySelector('[data-lightbox-next]');
    const lightboxClose = root.querySelector('[data-lightbox-close]');
    const lightboxSwipeArea = root.querySelector('[data-lightbox-swipe-area]');
    const lightboxThumbnails = [...root.querySelectorAll('[data-lightbox-thumbnail]')];
    const zoomButtons = [...root.querySelectorAll('[data-zoom-src]')];

    const lightboxItems = zoomButtons.map((button) => {
      const image = button.querySelector('img');

      return {
        src: button.dataset.zoomSrc || image?.currentSrc || image?.src || '',
        alt: image?.alt || root.querySelector('.sp-product-title')?.textContent?.trim() || ''
      };
    }).filter((item) => item.src);

    let lightboxIndex = 0;
    let touchStartX = null;

    const normalizeLightboxIndex = (index) => {
      if (!lightboxItems.length) return 0;
      return (index + lightboxItems.length) % lightboxItems.length;
    };

    const updateLightbox = (index) => {
      if (!lightbox || !lightboxImage || !lightboxItems.length) return;

      lightboxIndex = normalizeLightboxIndex(index);
      const item = lightboxItems[lightboxIndex];

      lightboxImage.src = item.src;
      lightboxImage.alt = item.alt;

      if (lightboxCounter) {
        lightboxCounter.textContent = `${lightboxIndex + 1} / ${lightboxItems.length}`;
      }

      lightboxThumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === lightboxIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');

        if (isActive) {
          thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });

      const hasMultipleImages = lightboxItems.length > 1;
      if (lightboxPrevious) lightboxPrevious.hidden = !hasMultipleImages;
      if (lightboxNext) lightboxNext.hidden = !hasMultipleImages;
    };

    const openLightbox = (index) => {
      if (!lightbox || !lightboxItems.length) return;

      updateLightbox(index);

      if (typeof lightbox.showModal === 'function') {
        if (!lightbox.open) lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
    };

    const closeLightbox = () => {
      if (!lightbox) return;

      if (typeof lightbox.close === 'function' && lightbox.open) {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
    };

    zoomButtons.forEach((button, index) => {
      button.addEventListener('click', () => openLightbox(index));
    });

    lightboxThumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => updateLightbox(index));
    });

    lightboxPrevious?.addEventListener('click', () => updateLightbox(lightboxIndex - 1));
    lightboxNext?.addEventListener('click', () => updateLightbox(lightboxIndex + 1));
    lightboxClose?.addEventListener('click', closeLightbox);

    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });

    lightbox?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        updateLightbox(lightboxIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        updateLightbox(lightboxIndex + 1);
      }

      if (event.key === 'Escape') {
        closeLightbox();
      }
    });

    lightboxSwipeArea?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });

    lightboxSwipeArea?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;

      const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
      const distance = touchEndX - touchStartX;
      touchStartX = null;

      if (Math.abs(distance) < 45) return;
      updateLightbox(distance > 0 ? lightboxIndex - 1 : lightboxIndex + 1);
    }, { passive: true });

    updateLightbox(0);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-soleah-product]').forEach(initProduct);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();